/* ============================================================
   Imperial TCG — wishlist.js
   localStorage-backed wishlist (no app). Stores an array of product
   handles under 'imperial:wishlist'. Marks/toggles any
   [data-wishlist-toggle] heart, keeps the header [data-wishlist-count]
   in sync, and renders the wishlist page grid by fetching each saved
   product via the AJAX /products/{handle}.js endpoint.
   Exposes window.ImperialWishlist.get().
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'imperial:wishlist';
  var cfg = window.themeConfig || {};

  function money(cents) {
    return (cfg.moneyFormat || '${{amount}}').replace('{{amount}}', (cents / 100).toFixed(2));
  }
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }

  function toggle(handle) {
    var arr = read();
    var i = arr.indexOf(handle);
    if (i === -1) { arr.push(handle); } else { arr.splice(i, 1); }
    write(arr);
    return i === -1; // true => now saved
  }

  /* ---------- header count ---------- */
  function updateCount() {
    var n = read().length;
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      if (n > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  /* ---------- mark hearts as pressed ---------- */
  function syncButtons(root) {
    $$('[data-wishlist-toggle]', root || document).forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      btn.setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
      btn.classList.toggle('is-on', has(handle));
    });
  }

  /* ---------- wishlist page rendering ---------- */
  function buildCard(product) {
    var card = document.createElement('div');
    card.className = 'card';
    card.setAttribute('data-wishlist-card', product.handle);

    var img = (product.featured_image || product.images && product.images[0]) || '';
    var imgSrc = img ? (img.indexOf('//') === 0 ? 'https:' + img : img) : '';
    var priceHtml = money(product.price);
    if (product.compare_at_price && product.compare_at_price > product.price) {
      priceHtml = '<s>' + money(product.compare_at_price) + '</s> ' + money(product.price);
    }
    var cat = product.type ? '<span class="card__cat">' + esc(product.type) + '</span>' : '';
    var mediaInner = imgSrc
      ? '<img src="' + esc(imgSrc) + '&width=600" alt="' + esc(product.title) + '" loading="lazy" width="600" height="600">'
      : '';

    card.innerHTML =
      '<a class="card__media" href="' + esc(product.url) + '">' + mediaInner +
        '<button type="button" class="wish-heart is-on" data-wishlist-toggle data-product-handle="' +
          esc(product.handle) + '" aria-pressed="true" aria-label="' + esc(removeLabel) + '">' + heartSvg + '</button>' +
      '</a>' +
      '<div class="card__body">' + cat +
        '<h3 class="card__title"><a href="' + esc(product.url) + '">' + esc(product.title) + '</a></h3>' +
        '<span class="price">' + priceHtml + '</span>' +
      '</div>';
    return card;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  var heartSvg = '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true" focusable="false"><path d="M12 20.5 4.2 12.7a4.6 4.6 0 0 1 6.5-6.5l1.3 1.3 1.3-1.3a4.6 4.6 0 0 1 6.5 6.5z" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var removeLabel = 'Remove from wishlist';

  function renderPage(grid) {
    var empty = $('[data-wishlist-empty]');
    var handles = read();

    // grab a heart svg + labels from an existing toggle if available (kept in sync with icon.liquid)
    var sample = $('[data-wishlist-toggle]');
    if (sample) { heartSvg = sample.innerHTML; }

    if (!handles.length) {
      grid.setAttribute('hidden', '');
      grid.innerHTML = '';
      if (empty) empty.removeAttribute('hidden');
      return;
    }
    if (empty) empty.setAttribute('hidden', '');
    grid.removeAttribute('hidden');
    grid.innerHTML = '';

    handles.forEach(function (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product) {
            // product no longer exists — prune it from storage
            var arr = read(); var i = arr.indexOf(handle);
            if (i !== -1) { arr.splice(i, 1); write(arr); updateCount(); }
            if (!read().length) { renderPage(grid); }
            return;
          }
          grid.appendChild(buildCard(product));
        })
        .catch(function () {});
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var nowSaved = toggle(handle);

    // sync every heart for this handle across the page
    $$('[data-wishlist-toggle][data-product-handle="' + (window.CSS && CSS.escape ? CSS.escape(handle) : handle) + '"]').forEach(function (b) {
      b.setAttribute('aria-pressed', nowSaved ? 'true' : 'false');
      b.classList.toggle('is-on', nowSaved);
    });
    updateCount();

    // on the wishlist page, removing a card should drop it from the grid
    var grid = $('[data-wishlist-grid]');
    if (grid && !nowSaved) {
      var card = btn.closest('[data-wishlist-card]');
      if (card) { card.remove(); }
      if (!read().length) { renderPage(grid); }
    }
  });

  function init() {
    updateCount();
    syncButtons();
    var grid = $('[data-wishlist-grid]');
    if (grid) { renderPage(grid); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.ImperialWishlist = { get: read, has: has, toggle: toggle };
})();
